import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const services = [
  "Klasik Masaj (60 dk)",
  "Sıcak Taş Masajı (90 dk)",
  "Aromaterapi Masajı",
  "Sporcu Masajı",
  "SPA Günü Paketi",
  "Detoks SPA Paketi",
  "Anti-Aging Cilt Bakımı",
  "Kese Köpük",
  "Finnish Sauna",
  "Buhar Odası",
  "Tuz Odası (Haloterapi)",
  "Profesyonel Manikür",
  "Profesyonel Pedikür",
];

const timeSlots = [
  "09:00 - 11:00",
  "11:00 - 13:00",
  "13:00 - 15:00",
  "15:00 - 17:00",
  "17:00 - 19:00",
  "19:00 - 21:00",
];

export default function OnlineRandevuPage() {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    service: services[0],
    datePreference: 'Bugün',
    timeSlot: timeSlots[0],
    personCount: 1,
    notes: '',
    source: 'Instagram Bio',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6" style={{ background: 'linear-gradient(135deg, #1A2E1A 0%, #0F1F0F 100%)' }}>
        <div className="w-full max-w-md text-center space-y-6 animate-fade-in">
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto" style={{ background: 'rgba(201,169,98,0.15)' }}>
            <i className="ri-check-double-line text-3xl" style={{ color: '#C9A962' }} />
          </div>
          <div>
            <h1 className="text-2xl font-bold font-display" style={{ color: '#E8E4DC' }}>Talebiniz Alındı</h1>
            <p className="text-sm mt-2" style={{ color: '#8A8680' }}>
              Randevu talebiniz en kısa sürede değerlendirilecektir. Size WhatsApp üzerinden bilgilendirme yapılacaktır.
            </p>
          </div>
          <div className="p-4 rounded-spa-sm text-left space-y-2" style={{ background: 'rgba(201,169,98,0.08)', border: '1px solid rgba(201,169,98,0.15)' }}>
            <p className="text-sm" style={{ color: '#E8E4DC' }}><span style={{ color: '#C9A962' }}>İsim:</span> {form.name}</p>
            <p className="text-sm" style={{ color: '#E8E4DC' }}><span style={{ color: '#C9A962' }}>Telefon:</span> {form.phone}</p>
            <p className="text-sm" style={{ color: '#E8E4DC' }}><span style={{ color: '#C9A962' }}>Hizmet:</span> {form.service}</p>
            <p className="text-sm" style={{ color: '#E8E4DC' }}><span style={{ color: '#C9A962' }}>Tercih:</span> {form.datePreference} | {form.timeSlot}</p>
          </div>
          <a
            href={`https://wa.me/+902125556677?text=Merhaba,+Kuğu+Spa'ya+randevu+talebi+gönderdim.+Talep+numaram:+${Date.now()}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-spa-sm text-sm font-medium text-white transition-all cursor-pointer"
            style={{ background: 'linear-gradient(135deg, #10B981, #059669)' }}
          >
            <i className="ri-whatsapp-line" />
            WhatsApp'tan Devam Et
          </a>
          <button
            onClick={() => { setSubmitted(false); setForm({ name: '', phone: '', service: services[0], datePreference: 'Bugün', timeSlot: timeSlots[0], personCount: 1, notes: '', source: 'Instagram Bio' }); }}
            className="block mx-auto text-xs mt-4 cursor-pointer"
            style={{ color: '#8A8680' }}
          >
            Yeni talep oluştur
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(135deg, #FAF6F0 0%, #F5F0E8 100%)' }}>
      {/* Header */}
      <header className="px-6 py-6 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/1d51f5ffde24df2b1cca180a545c35bd.jpeg"
            alt="Kuğu Spa"
            className="w-12 h-12 rounded-full object-cover"
          />
          <div>
            <h1 className="text-lg font-bold font-display" style={{ color: '#1A1A1A' }}>Kuğu Spa</h1>
            <p className="text-xs" style={{ color: '#6B6560' }}>Premium Wellness & Spa</p>
          </div>
        </div>
      </header>

      {/* Form */}
      <main className="px-6 pb-12 max-w-md mx-auto">
        <div className="mb-6">
          <h2 className="text-xl font-bold font-display" style={{ color: '#1A1A1A' }}>Online Randevu</h2>
          <p className="text-sm mt-1" style={{ color: '#6B6560' }}>Bilgilerinizi doldurun, size en kısa sürede dönüş yapalım.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Adınız Soyadınız *</label>
            <input
              required
              className="w-full px-4 py-3 rounded-spa-sm text-sm outline-none transition-all"
              style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              placeholder="Örn: Ayşe Yılmaz"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
            />
          </div>

          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Telefon Numaranız *</label>
            <input
              required
              type="tel"
              className="w-full px-4 py-3 rounded-spa-sm text-sm outline-none transition-all"
              style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              placeholder="+90 5XX XXX XXXX"
              value={form.phone}
              onChange={e => setForm({ ...form, phone: e.target.value })}
            />
          </div>

          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Hizmet Seçimi *</label>
            <select
              required
              className="w-full px-4 py-3 rounded-spa-sm text-sm outline-none transition-all"
              style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              value={form.service}
              onChange={e => setForm({ ...form, service: e.target.value })}
            >
              {services.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Tarih Tercihi *</label>
            <div className="flex gap-2">
              {['Bugün', 'Yarın'].map(opt => (
                <button
                  key={opt}
                  type="button"
                  onClick={() => setForm({ ...form, datePreference: opt })}
                  className="flex-1 py-3 rounded-spa-sm text-sm font-medium cursor-pointer transition-all border"
                  style={{
                    background: form.datePreference === opt ? '#C9A962' : '#FFFFFF',
                    color: form.datePreference === opt ? '#FFFFFF' : '#1A1A1A',
                    borderColor: form.datePreference === opt ? '#C9A962' : '#E5DDD3',
                  }}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Saat Aralığı *</label>
            <select
              required
              className="w-full px-4 py-3 rounded-spa-sm text-sm outline-none transition-all"
              style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              value={form.timeSlot}
              onChange={e => setForm({ ...form, timeSlot: e.target.value })}
            >
              {timeSlots.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>

          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Kişi Sayısı</label>
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => setForm({ ...form, personCount: Math.max(1, form.personCount - 1) })}
                className="w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold cursor-pointer"
                style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              >
                -
              </button>
              <span className="text-lg font-semibold w-8 text-center" style={{ color: '#1A1A1A' }}>{form.personCount}</span>
              <button
                type="button"
                onClick={() => setForm({ ...form, personCount: Math.min(10, form.personCount + 1) })}
                className="w-10 h-10 rounded-full flex items-center justify-center text-lg font-bold cursor-pointer"
                style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              >
                +
              </button>
            </div>
          </div>

          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Not (İsteğe Bağlı)</label>
            <textarea
              className="w-full px-4 py-3 rounded-spa-sm text-sm outline-none transition-all resize-none"
              style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              maxLength={500}
              rows={3}
              placeholder="Özel istekleriniz, sağlık durumunuz vb..."
              value={form.notes}
              onChange={e => setForm({ ...form, notes: e.target.value })}
            />
          </div>

          <div>
            <label className="text-xs font-medium mb-1.5 block" style={{ color: '#6B6560' }}>Nereden duydunuz?</label>
            <select
              className="w-full px-4 py-3 rounded-spa-sm text-sm outline-none transition-all"
              style={{ background: '#FFFFFF', border: '1px solid #E5DDD3', color: '#1A1A1A' }}
              value={form.source}
              onChange={e => setForm({ ...form, source: e.target.value })}
            >
              <option value="Instagram Bio">Instagram</option>
              <option value="Google">Google</option>
              <option value="Meta">Facebook / Meta</option>
              <option value="WhatsApp">WhatsApp</option>
              <option value="Tavsiye">Tavsiye</option>
              <option value="Diğer">Diğer</option>
            </select>
          </div>

          <button
            type="submit"
            className="w-full py-3.5 rounded-spa-sm text-sm font-medium text-white transition-all cursor-pointer"
            style={{ background: 'linear-gradient(135deg, #C9A962, #A88942)' }}
          >
            Randevu Talebi Gönder
          </button>

          <div className="flex items-center justify-center gap-2 pt-2">
            <a href="tel:+902125556677" className="text-xs flex items-center gap-1" style={{ color: '#6B6560' }}>
              <i className="ri-phone-line" />Hemen Ara
            </a>
            <span style={{ color: '#E5DDD3' }}>|</span>
            <a href="https://wa.me/+902125556677" target="_blank" rel="noopener noreferrer" className="text-xs flex items-center gap-1" style={{ color: '#10B981' }}>
              <i className="ri-whatsapp-line" />WhatsApp
            </a>
          </div>
        </form>
      </main>
    </div>
  );
}